
<div class="card m-0" [style.border-color]="primaryColour">
    <div class="card-header">
        <div class="card-header-title mb-2 mb-md-0">
            {{ title }}
        </div>
    </div>
    <div class="card-body chart-parent">
        <div #turnaroundGraphContainer id="turnaroundGraphContainer" class="justify-content-center align-self-center">
            <ngx-charts-line-chart
                [scheme]="colorScheme"
                [legend]="legend"
                [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel"
                [xAxis]="xAxis"
                [yAxis]="yAxis"
                [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel"
                [timeline]="timeline"
                [results]="data"
                autoScale="true">
            </ngx-charts-line-chart>
        </div>
    </div>
</div>